import PropTypes from "prop-types";

import assignmentPropTypes from "@/assignments/utils/assignmentPropTypes";
import StudentAssignmentFootnote from "./StudentAssignmentFootnote";
import StudentAssignmentInformation from "./StudentAssignmentInformation";
import StudentAssignmentInstructions from "./StudentAssignmentInstructions";
import StudentAssignmentTitle from "./StudentAssignmentTitle";

const propTypes = {
  __cssFor: PropTypes.shape({
    information: PropTypes.object,
    instructions: PropTypes.object,
    root: PropTypes.object,
    title: PropTypes.object,
  }),
  assignment: assignmentPropTypes,
  currentContentLevelId: PropTypes.string,
  hasMultipleAssignments: PropTypes.bool,
};

const AssignmentEmbedStudentContainer = ({
  __cssFor,
  assignment,
  currentContentLevelId,
  hasMultipleAssignments,
}) => {
  return (
    <div css={__cssFor?.root}>
      <StudentAssignmentTitle __cssFor={{ root: __cssFor?.title }}>
        {assignment?.title}
      </StudentAssignmentTitle>
      <StudentAssignmentInformation
        assignment={assignment}
        __cssFor={{ information: __cssFor?.information }}
      />
      <StudentAssignmentInstructions
        instructions={assignment?.instructions}
        __cssFor={{ instructions: __cssFor?.instructions }}
      />
      <StudentAssignmentFootnote
        assignmentId={assignment?.content_id}
        currentContentLevelId={currentContentLevelId}
        hasMultipleAssignments={hasMultipleAssignments}
      />
    </div>
  );
};

AssignmentEmbedStudentContainer.propTypes = propTypes;

export default AssignmentEmbedStudentContainer;
